import toast from "react-hot-toast";
import { useForm } from "react-hook-form";
import { useMutation } from "@tanstack/react-query";
import { Link, useNavigate } from "react-router-dom";

import type { ForgotPasswordDto } from "~/data/user/forgot-password.dto";

import { forgotPassword } from "~/data/user/user.service";

import { Input } from "../shared/input";
import { Field } from "../shared/field";
import { Button } from "../shared/button";

export function ForgotPassword() {
  const form = useForm<ForgotPasswordDto>();
  const mutation = useMutation({
    mutationFn: (dto: ForgotPasswordDto) => forgotPassword(dto),
  });
  const navigate = useNavigate();
  return (
    <form
      onSubmit={form.handleSubmit((dto) =>
        mutation.mutate(dto, {
          onSuccess: () => {
            navigate("/entrar");
            toast(
              "Um link foi enviado ao seu e-mail para recuperar sua senha!"
            );
          },
        })
      )}
      className="flex flex-col items-center w-full"
    >
      <h2 className="text-primary-1 text-2xl lg:text-3xl font-semibold mb-5 lg:mb-10 text-center">
        Recuperar senha
      </h2>

      <div className="w-[460px] max-w-full mb-5 lg:mb-10">
        <Field label="E-mail">
          <Input
            {...form.register("email", { required: "Campo obrigatório" })}
            placeholder="Informe um e-mail válido "
            type="email"
          />
        </Field>
      </div>

      <Button
        className="h-10 w-60 max-w-full my-5"
        loading={mutation.isPending}
        type="submit"
        variant="primary-1"
      >
        Enviar nova senha
      </Button>
      <Button
        className="h-10 w-60 max-w-full mb-10"
        asChild
        variant="primary-1"
      >
        <Link to="/entrar">Voltar para Login</Link>
      </Button>
    </form>
  );
}
